<div *ngIf="!success">
  <h2 class="nomargin">{{ 'FORGOTPW.HEADING' | transloco }}</h2>
  <span class="helper__text">{{ 'FORGOTPW.SUBHEADING' | transloco }}</span>

  <form
    *ngIf="!success"
    [formGroup]="forgotPwForm"
    class="login__form"
    (ngSubmit)="forgotPwForm.valid && sendPasswordReminder(forgotPwForm.get('email').value)">
    <label for="email">Email</label>
    <mat-form-field class="fw">
      <input matInput placeholder="username@example.com" formControlName="email" type="email" />
      <mat-error *ngIf="forgotPwForm.get('email').hasError('email') && !forgotPwForm.get('email').hasError('required')">
        {{ 'CORE.VALID_EMAIL' | transloco }}
      </mat-error>
      <mat-error *ngIf="forgotPwForm.get('email').hasError('required')">
        {{ 'CORE.EMAIL' | transloco }} {{ 'CORE.IS_REQUIRED' | transloco }}
      </mat-error>
    </mat-form-field>

    <button [disabled]="loading" class="login__btn-submit fw" type="submit" mat-flat-button color="primary">
      {{ 'FORGOTPW.RESET_PASSWORD' | transloco }}
      <mat-spinner class="button__spinner" *ngIf="loading" diameter="22" color="accent"></mat-spinner>
    </button>
  </form>
</div>

<div *ngIf="success">
  <h2 class="nomargin">{{ 'FORGOTPW.SUCCESS.HEADING' | transloco }}</h2>
  <span class="helper__text">{{ 'FORGOTPW.SUCCESS.SUBHEADING' | transloco }}</span>
</div>
